export enum BranchTypeEnum {
        Main = 72,
        Branch = 73,
}
